import Vue from 'vue'
import Vuex from 'vuex'
import { Message } from 'element-ui'

import { userInfo, logout, apiMyMenus } from '@/api/login'
import { apiMenuList, apiMenuTree } from '@/api/account'
import router from '@/router'
import {
  apiSignStatus,
  apiCheckStatus,
  apiRealNameStatus,
  apiIndustries,
  apiGender,
  apiEducation,
  apiHasCar,
  apiMarriage,
  apiPayments,
  apiUserTypes,
  apiShowStatus,
  apiMatchmakers,
  apiRegion,
  apiHasHouse,
  apiArriveStatus,
  apiLoveHistory,
  apiSingleStatus,
  apiCarRequirement,
  apiHouseRequirement,
  apiEducationalRequirement,
} from '@/api/selector'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    selectorData: {
      matchmakers: {
        promise: apiMatchmakers,
        data: [],
        dataMap: {},
      },
      signStatus: {
        promise: apiSignStatus,
        data: [],
        dataMap: {},
      },
      checkStatus: {
        promise: apiCheckStatus,
        data: [],
        dataMap: {},
      },
      realNameStatus: {
        promise: apiRealNameStatus,
        data: [],
        dataMap: {},
      },
      industries: {
        promise: apiIndustries,
        data: [],
        dataMap: {},
      },
      gender: {
        promise: apiGender,
        data: [],
        dataMap: {},
      },
      education: {
        promise: apiEducation,
        data: [],
        dataMap: {},
      },
      hasCar: {
        promise: apiHasCar,
        data: [],
        dataMap: {},
      },
      marriage: {
        promise: apiMarriage,
        data: [],
        dataMap: {},
      },
      payments: {
        promise: apiPayments,
        data: [],
        dataMap: {},
      },
      userTypes: {
        promise: apiUserTypes,
        data: [],
        dataMap: {},
      },
      showStatus: {
        promise: apiShowStatus,
        data: [],
        dataMap: {},
      },
      region: {
        promise: apiRegion,
        data: [],
        dataMap: {},
      },
      arriveStatus: {
        promise: apiArriveStatus,
        data: [],
        dataMap: {},
      },
      hasHouse: {
        promise: apiHasHouse,
        data: [],
        dataMap: {},
      },
      loveHistory: {
        promise: apiLoveHistory,
        data: [],
        dataMap: {},
      },
      singleStatus: {
        promise: apiSingleStatus,
        data: [],
        dataMap: {},
      },
      carRequirement: {
        promise: apiCarRequirement,
        data: [],
        dataMap: {},
      },
      houseRequirement: {
        promise: apiHouseRequirement,
        data: [],
        dataMap: {},
      },
      educationalRequirement: {
        promise: apiEducationalRequirement,
        data: [],
        dataMap: {},
      },
    },
    menuList: [],
    menuTree: [],
    myMenus: [],
    simpleMode: false,
    myMenuMap: {},
  },
  getters: {
    menuListMap(state) {
      return state.menuList.reduce((prev, current) => {
        prev[current.path] = true
        return prev
      }, {})
    },
    myMenusMap(state) {
      return state.myMenus.reduce((prev, current) => {
        prev[current.path] = true
        return prev
      }, {})
    },
    isSuper(state) {
      return !!state.userInfo.is_super
    },
    isMatchmaker(state) {
      if (!state.userInfo.id) return false
      return !!state.selectorData.matchmakers.dataMap[state.userInfo.id]
    },
  },
  mutations: {
    setUserInfo(state, val) {
      state.userInfo = val
    },
    setSelectorData(state, val) {
      state.selectorData = val
    },
    setMatchMakerList(state, val) {
      state.matchMakerList = val
    },
    setMenuList(state, val) {
      state.menuList = val
    },
    setMenuTree(state, val) {
      state.menuTree = val
    },
    setMyMenus(state, val) {
      state.myMenus = val
    },
    setSimpleMode(state, val) {
      state.simpleMode = val
    },
  },
  actions: {
    async getUserInfo({ commit, dispatch }) {
      try {
        const res = await userInfo()
        await dispatch('getMyMenu')
        commit('setUserInfo', res.d)
        dispatch('getSelectorData')
        dispatch('getMenuList')
        return Promise.resolve(res)
      } catch (err) {
        console.log(err)
        return Promise.reject(err)
      }
    },
    async logout({ commit }) {
      try {
        const res = await logout()
        if (res.c === 200) {
          commit('setUserInfo', {})
          Message.success(res.m)
          router.replace('/login')
          return Promise.resolve(res)
        } else {
          throw new Error()
        }
      } catch (err) {
        Message.error('注销失败')
      }
    },
    getSelectorData({ state, commit }) {
      Object.keys(state.selectorData).forEach(key => {
        if (!state.selectorData[key].data.length) {
          state.selectorData[key].promise().then(res => {
            state.selectorData[key].data = res.d
            if (res.d[0]?.name || res.d[0]?.industry_name || res.d[0]?.nickname || res.d[0]?.username) {
              state.selectorData[key].dataMap = res.d.reduce((prev, current) => {
                prev[current.id] = current.name || current.industry_name || current.nickname || current.username
                return prev
              }, {})
            }
            commit('setSelectorData', state.selectorData)
          })
        }
      })
    },
    getMenuList({ commit }) {
      apiMenuList()
        .then(res => {
          commit('setMenuList', res.d)
        })
        .catch(err => {
          this.$message.error(err.m || '请求失败')
        })
      apiMenuTree()
        .then(res => {
          commit('setMenuTree', res.d)
        })
        .catch(err => {
          this.$message.error(err.m || '请求失败')
        })
    },
    getMyMenu({ commit }) {
      return apiMyMenus()
        .then(res => {
          commit('setMyMenus', res.d)
        })
        .catch(err => {
          this.$message.error(err.m || '获取权限失败')
        })
    },
  },
})
